import React from "react";
import { TabContent, TabPane } from "reactstrap";
import { AnimatedHorizontalTabsData } from "../../../../Data/UiKits/Tabs";
import { SimpleTabContentProp } from "../../../../Types/UiKitsType";

const AnimatedHorizontalTabsContent: React.FC<SimpleTabContentProp> = ({ tabId }) => {
  return (
    <TabContent activeTab={tabId}>
      {AnimatedHorizontalTabsData &&
        AnimatedHorizontalTabsData.map((item, index) => (
          <TabPane className={`fade ${tabId === item.id ? "show" : ""}`} tabId={item.id} key={index}>
            {item.text}
          </TabPane>
        ))}
    </TabContent>
  );
};
export default AnimatedHorizontalTabsContent;
